import { fromJS, Map } from "immutable";
import * as actionTypes from "~/store/action_types";

const mergeEntities = (state, newProjectTemplates) => {
  return state.merge(newProjectTemplates.map((s) => fromJS(s)));
};

const project_templates = (state = Map(), action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROJECT_TEMPLATES_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { projectTemplates = {} } = entities;

      return mergeEntities(state, fromJS(projectTemplates));
    }
    case actionTypes.CONVERT_TO_TEMPLATE_SUCCESS:
    case actionTypes.DUPLICATE_PROJECT_TEMPLATE_SUCCESS:
    case actionTypes.ADD_PROJECT_TEMPLATE_SUCCESS:
    case actionTypes.MOVE_PROJECT_TEMPLATE_TO_TRASH_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { projectTemplates = {} } = entities;
      const { single: id = 0 } = result;

      if (id && projectTemplates[id]) {
        return state.set(`${id}`, fromJS(projectTemplates[id]));
      }

      return state;
    }
    case actionTypes.PROJECT_TEMPLATE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.PROJECT_TEMPLATE_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.ADD_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS:
    case actionTypes.FETCH_PROJECT_TEMPLATE_SUCCESS:
    case actionTypes.EDIT_PROJECT_TEMPLATE_SUCCESS:
    case actionTypes.EDIT_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {}, id = 0 } = action;
      const { entities = {} } = response;
      const { projectTemplates = {} } = entities;
      if (id && projectTemplates[id]) {
        return state.set(`${id}`, fromJS(projectTemplates[id]));
      }

      return state;
    }
    default:
      return state;
  }
};

export default project_templates;
